import auth from '../../../config/app-specific-config/auth';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';
import { 
  GET_DSR_INVITE_LINK_REQUEST, 
  GET_DSR_INVITE_LINK_FAILURE, 
  GET_DSR_INVITE_LINK_SUCCESS,
  GET_DSR_INVITE_LINK_RESET
 } from "./dsr-invite-actions-types";


export const getDsrInviteLinkSuccess = (response) => {
	return {
		type: GET_DSR_INVITE_LINK_SUCCESS,
		payload: response.data
	};
};


export const getDsrInviteLinkFailure = (error) => {
	return {
		type: GET_DSR_INVITE_LINK_FAILURE,
		error
	};
};

export const getDsrInviteLinkRequest = () => {
	return {
		type: GET_DSR_INVITE_LINK_REQUEST
	};
};


export function getDsrInviteLink(getInviteLinkMetadata) {
	return async (dispatch) => {
		dispatch(getDsrInviteLinkRequest());
		try {
			const url = '/users/get-dsr-invite-link';
			const headers = await auth.getAccessToken();

			const response = await axiosInstance.post(
				url,
				getInviteLinkMetadata,
				{ headers }
			);
			dispatch(getDsrInviteLinkSuccess(response));

		} catch (error) {
			dispatch(getDsrInviteLinkFailure(error));
		}

	};
}

// Reset
export const getDsrInviteLinkReset = () => {
	return {
		type: GET_DSR_INVITE_LINK_RESET
	};
};

export function resetGetDsrInviteLink() {

	return async (dispatch) => {

		try {
			dispatch(getDsrInviteLinkReset());

		} catch (error) {
			dispatch(getDsrInviteLinkFailure(error));
		}
	};
}